<template>
  <div v-if="(show || showEventTutorial) && slides.length > 0" class="radio radio--tutorial">
    <div class="radio--tutorial__cover" />
    <div
      v-for="(slide, index) in slides"
      :key="slide.index"
      :class="{
        'radio--tutorial--template1': slide.frontend_template === 'radce1',
        'radio--tutorial--template2': slide.frontend_template === 'radce2',
        'radio--tutorial--template3': slide.frontend_template === 'radce3',
        'radio--tutorial--small': slide.frontend_template === 'radce1',
        'radio--tutorial--large': slide.frontend_template === 'radce3',
        active: slide.id === slideActive.id
      }"
      class="radio--tutorial__slide"
    >
      <div
        v-if="!show && showEventTutorial"
        class="radio--tutorial__close"
        @click="
          () => {
            index + 1 === slides.length ? closeEventTutorial(index) : showLater()
            removeClassLighted()
          }
        "
      >
        <img src="@/assets/icons/actions/ico-delete.svg" />
      </div>
      <div
        v-else
        class="radio--tutorial__close"
        @click="
          () => {
            close(index)
            removeClassLighted()
          }
        "
      >
        <img src="@/assets/icons/actions/ico-delete.svg" />
      </div>

      <div v-if="slide.frontend_template === 'radce1'" class="radio--tutorial__content text-center">
        <img v-if="slide.main_foto" :src="path + '/foto/clanky/' + slide.main_foto" />
        <h1 class="text-center" v-html="slide.nadpis" />
        <div class="radio--tutorial__content__perex" v-html="slide.perex" />
        <div v-html="slide.text" />
      </div>
      <div v-if="slide.frontend_template === 'radce2'" class="radio--tutorial__content">
        <h1 class="text-center" v-html="slide.nadpis" />
        <div class="radio--tutorial__row row">
          <div class="col-sm-6">
            <div class="radio--tutorial__content__perex pr-md-3" v-html="slide.perex" />
          </div>
          <div v-if="slide.main_foto" class="col-sm-6">
            <div class="radio--tutorial__imageWrapper">
              <img :src="path + '/foto/clanky/' + slide.main_foto" />
            </div>
          </div>
        </div>
        <div
          v-if="slide.custom_fields.secondRowText || slide.custom_fields.secondRowImage"
          class="radio--tutorial__row row"
        >
          <div class="col-sm-6">
            <div class="radio--tutorial__content__perex pr-md-3" v-html="slide.custom_fields.secondRowText" />
          </div>
          <div v-if="slide.custom_fields.secondRowImage" class="col-sm-6">
            <div class="radio--tutorial__imageWrapper">
              <img :src="path + '/foto/custom_fields/' + slide.custom_fields.secondRowImage" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="slide.frontend_template === 'radce3'" class="radio--tutorial__content">
        <h1 class="text-center" v-html="slide.nadpis" />
        <div class="text-center" v-html="slide.perex" />
        <div class="row">
          <div class="col-sm-4">
            <div class="d-flex radio--tutorial__steps">
              <div class="atom-circle atom-circle--success">1</div>
              <div v-html="slide.custom_fields.step1Text" />
            </div>
            <div v-if="slide.custom_fields.step1Image" class="radio--tutorial__imageWrapper">
              <img :src="path + '/foto/custom_fields/' + slide.custom_fields.step1Image" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="d-flex radio--tutorial__steps">
              <div class="atom-circle atom-circle--success">2</div>
              <div v-html="slide.custom_fields.step2Text" />
            </div>
            <div v-if="slide.custom_fields.step2Image" class="radio--tutorial__imageWrapper">
              <img :src="path + '/foto/custom_fields/' + slide.custom_fields.step2Image" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="d-flex radio--tutorial__steps">
              <div class="atom-circle atom-circle--success">3</div>
              <div v-html="slide.custom_fields.step3Text" />
            </div>
            <div v-if="slide.custom_fields.step3Image" class="radio--tutorial__imageWrapper">
              <img :src="path + '/foto/custom_fields/' + slide.custom_fields.step3Image" />
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="index !== 0 && index !== slides.length - 1"
        class="radio--tutorial__buttons d-flex align-items-center justify-content-center"
      >
        <button class="btn btn-link" @click="prevSlide()">
          {{ $t("zpet") }}
        </button>
        <button v-if="index !== slides.length - 1" class="btn btn-primary" @click="nextSlide()">
          {{ $t("pokracovat") }}
        </button>
      </div>
      <div v-if="index === 0" class="radio--tutorial__buttons text-center">
        <div v-if="!show && showEventTutorial">
          <button class="btn btn-primary" @click="nextSlide()">
            {{ $t("BUTTON_EVENT_TUTORIAL_ZACIT") }}
          </button>
          <button class="btn btn-link" @click="closeEventTutorial()">
            {{ $t("BUTTON_EVENT_TUTORIAL_ZAVRIT") }}
          </button>
        </div>
        <div v-else>
          <button class="btn btn-primary" @click="nextSlide()">
            {{ $t("zahajitProhlidku") }}
          </button>
          <button class="btn btn-link" @click="showLater()">
            {{ $t("pozdejiProsim") }}
          </button>
        </div>
      </div>
      <div v-if="index === slides.length - 1 && notShowImportBtn === true" class="radio--tutorial__buttons text-center">
        <button class="btn btn-link gray-text-light" @click="prevSlide()">
          {{ $t("zpet") }}
        </button>
        <button class="btn btn-link" @click="close(index)">
          {{ $t("zavrit") }}
        </button>
      </div>
      <div v-if="index === slides.length - 1 && notShowImportBtn !== true">
        <div v-if="!show && showEventTutorial">
          <RouterLink
            :to="{
              name: 'devices',
              params: {
                customerId: customerId,
                projectId: projectId
              }
            }"
            class="link-gray"
          >
            <button class="btn btn-primary" @click="closeEventTutorial(index)">
              {{ $t("BUTTON_EVENT_TUTORIAL_NA_ZARIZENI") }}
            </button>
          </RouterLink>
          <button class="btn btn-link" @click="closeEventTutorial(index)">
            {{ $t("BUTTON_EVENT_TUTORIAL_ZAVRIT") }}
          </button>
        </div>

        <div v-else>
          <!-- new customer admin has button to admin menu -->
          <button v-if="apiUser && newUser && apiUser.isCustomerAdmin" class="btn btn-primary" @click="toAdminMenu()">
            {{ $t("Začít s vytvořením Projektu") }}
          </button>
          <button v-else class="btn btn-primary" @click="toImport()">
            {{ $t("zacitSImportem") }}
          </button>
          <button class="btn btn-link" @click="close(index)">
            {{ $t("tedNeDiky") }}
          </button>
        </div>
      </div>
      <div class="radio--tutorial__paginator d-flex align-items-center justify-content-center">
        <div
          v-for="(slide, index) in slides"
          :key="slide.index"
          :class="{ active: slide.id === slideActive.id }"
          class="radio--tutorial__page"
          @click="toSlide(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
import axios from "axios"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  props: {
    userRole: String
  },
  setup() {
    const authStore = useAuthStore()
    const configStore = useConfigStore()

    return { authStore, configStore }
  },
  data() {
    return {
      projectId: this.$router.currentRoute.value.params.projectId,
      customerId: this.$router.currentRoute.value.params.customerId,
      newUser: true,
      notShowImportBtn: false,
      slideActive: {},
      slides: [],
      pathAPI: process.env.VUE_APP_APICMS,
      path: process.env.VUE_APP_CMS
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    showTutorial() {
      return this.configStore.shouldShowTutorial
    },
    showEventTutorial() {
      return this.configStore.shouldShowEventTutorial
    },
    show() {
      if (this.$router.currentRoute.value.name === "adminMenu") {
        return !(this.configStore.shouldShowTutorialAdmin === false || !this.configStore.isAdminTutorialVisible)
      } else {
        return !(this.configStore.shouldShowTutorial === false || !this.configStore.isTutorialVisible)
      }
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    slideActive() {
      this.markTargets()
    },
    locale() {
      this.loadSlides()
    }
  },
  mounted() {
    this.loadSlides()
  },
  methods: {
    nextSlide() {
      let indexOfCurrent = this.slides.indexOf(this.slideActive)
      let idexOfNext = indexOfCurrent + 1
      let nextSlide = this.slides[idexOfNext]
      this.slideActive = nextSlide
    },
    toSlide(index) {
      this.slideActive = this.slides[index]
    },
    toAdminMenu() {
      this.show = false
      $(".lighted").removeClass("lighted")
      this.configStore.isTutorialVisible = false
      this.$router.push({ name: "admin", params: { customerId: this.customerId, projectId: this.projectId } })
    },
    prevSlide() {
      let indexOfCurrent = this.slides.indexOf(this.slideActive)
      let idexOfPrev = indexOfCurrent - 1
      let prevSlide = this.slides[idexOfPrev]
      this.slideActive = prevSlide
    },
    setActive() {
      this.slideActive = this.slides[0]
    },
    removeClassLighted() {
      $(".lighted").removeClass("lighted")
    },
    markTargets() {
      $(".lighted").removeClass("lighted")

      Object.values(this.slideActive.tags_array).forEach(function (value) {
        $("#" + value).addClass("lighted")
      })
    },
    close(index) {
      /**
       * closing last slide - hide tutorial premanetly
       */
      if (index + 1 === this.slides.length) {
        $(".lighted").removeClass("lighted")
        if (this.$router.currentRoute.value.name === "adminMenu") {
          this.configStore.setShouldShowTutorialAdmin(false)
        } else {
          this.configStore.setShouldShowTutorial(false)
        }
      } else {
        if (this.$router.currentRoute.value.name === "adminMenu") {
          /**
           * hide tutorial until next login
           */
          this.configStore.isAdminTutorialVisible = false
          localStorage.setItem("showTutorialLaterAdmin", JSON.stringify(true))
        } else {
          /**
           * hide tutorial until next login
           */
          this.configStore.isTutorialVisible = false
          localStorage.setItem("showTutorialLater", JSON.stringify(true))

          this.configStore.isEventTutorialVisible = false
          localStorage.setItem("showEventTutorialLater", JSON.stringify(true))
        }
      }
    },
    closeEventTutorial() {
      /**
       * closing the event tutorial - hide it permanently
       */
      $(".lighted").removeClass("lighted")
      this.configStore.setShouldShowEventTutorial(false)
      this.configStore.isEventTutorialVisible = false
    },
    showLater() {
      if (this.$router.currentRoute.value.name === "adminMenu") {
        this.configStore.isAdminTutorialVisible = false
        this.configStore.setShouldShowTutorialAdmin(false)
        localStorage.setItem("showTutorialLaterAdmin", JSON.stringify(true))
      } else {
        this.configStore.isTutorialVisible = false
        this.configStore.isEventTutorialVisible = false
        localStorage.setItem("showTutorialLater", JSON.stringify(true))
        localStorage.setItem("showEventTutorialLater", JSON.stringify(true))
      }
    },
    toImport() {
      this.show = false
      $(".lighted").removeClass("lighted")
      this.configStore.isTutorialVisible = false
      this.$router.push({
        name: "import",
        params: {
          customerId: this.customerId,
          projectId: this.projectId
        }
      })
    },
    loadSlides() {
      if (this.$router.currentRoute.value.name === "adminMenu") {
        this.notShowImportBtn = true
      }

      /**
       * switch tutorial for defined userRole in this.userRole
       */
      let tutorialPath = ""
      let disableTutorial = false

      if (this.apiUser) {
        /**
         * old user
         */
        if (this.apiUser.createdAt === "2000-01-01T00:00:00.000Z") {
          this.newUser = false
        }

        /**
         * old user has event tutorial
         */
        if (this.newUser == false) {
          if (this.showTutorial) {
            tutorialPath = "/article/tutorial"
          } else if (this.showEventTutorial) {
            tutorialPath = "/article/tutorial-event"
          } else if (this.$router.currentRoute.value.name !== "adminMenu") {
            disableTutorial = true
          }
        } else {
          /**
           * new user
           */
          if (this.showTutorial) {
            /**
             * new user
             */
            if (this.apiUser.highestPrivilege === "CustomerAdmin" || this.apiUser.highestPrivilege === "IotAdmin") {
              tutorialPath = "/article/tutorial-spravce"
            } else if (this.apiUser.highestPrivilege === "ProjectAdmin") {
              tutorialPath = "/article/tutorial-uzivatel"
            } else disableTutorial = true
          } else if (this.showEventTutorial) {
            tutorialPath = "/article/tutorial-event"
          } else if (this.$router.currentRoute.value.name !== "adminMenu") disableTutorial = true
        }

        if (this.$router.currentRoute.value.name === "adminMenu") {
          tutorialPath = "/article/tutorial-admin"
        }

        if (disableTutorial === false)
          axios
            .get(process.env.VUE_APP_APICMS + "/" + this.locale + tutorialPath, {
              crossdomain: true
            })
            .then((response) => {
              if (typeof response.data == "object") {
                this.slides = response.data
              } else {
                this.slides = []
              }

              this.setActive()
            })
            .catch(() => {
              this.slides = []
            })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
